module.exports = __webpack_public_path__ + "img/PRNT_01_mono_AE_00003.1e0d1f7d.png";